module.exports = __webpack_public_path__ + "static/media/loc1_img16.0670d1f8.jpg";